import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './routes/App';
import Dashboard from './routes/Dashboard';
import Players from './routes/Players';
import Player from './routes/Player';
import Team from './routes/Team';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'players', element: <Players /> },
      { path: 'player/:id', element: <Player /> },
      { path: 'teams/:id', element: <Team /> }
    ]
  }
]);

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);



